import React from "react";
import { Link } from "react-router-dom";
import FrontendLayout from "../../components/frontend/FrontendLayout";

const TermsandCondition: React.FC = () => {
  return (
    <FrontendLayout>
      <section
        className="flat-title style-2 mb-4 tf-spacing-1"
        style={{ background: "#f9e7e4" }}
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>T&C</li>
                </ul>
                <h5 className="mt-3">Terms and Conditions</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-box-team style-2 tf-spacing-1 pb-0">
        <div className="tf-container tf-spacing-1 pt-0">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="wg-property box-amenities border-0 p-0">
                <h4 className="title mb-4">Terms and Conditions</h4>
                <div className="wrap-feature">
                  <div className="box-feature">
                    <ul>
                      <li className="feature-item">
                        By accessing or using MyLandMart, you agree to be bound by these Terms and Conditions. If you do not agree, you may not use our services.
                      </li>
                      <li className="feature-item">
                        You must be at least 18 years old to use MyLandMart. By using our services, you represent that you meet this age requirement.
                      </li>
                      <li className="feature-item">
                        All content provided on MyLandMart, including text, images, and other materials, is for informational purposes only and does not constitute professional advice.
                      </li>
                      <li className="feature-item">
                        Users are responsible for maintaining the confidentiality of their account information, including passwords, and for all activities that occur under their account.
                      </li>
                      <li className="feature-item">
                        MyLandMart reserves the right to modify or terminate services at any time without prior notice. We are not liable for any losses resulting from such changes.
                      </li>
                      <li className="feature-item">
                        You agree not to use MyLandMart for any unlawful or prohibited activities, including but not limited to distributing harmful code, engaging in fraudulent activities, or violating intellectual property rights.
                      </li>
                      <li className="feature-item">
                        MyLandMart may contain links to third-party websites. We are not responsible for the content, accuracy, or practices of these websites.
                      </li>
                      <li className="feature-item">
                        We may update these Terms and Conditions from time to time. Any changes will be posted on this page, and your continued use of MyLandMart constitutes acceptance of the updated terms.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </FrontendLayout>
  );
};

export default TermsandCondition;